import {createStyles} from '@mantine/core';
import React from 'react';

const useStyles = createStyles(() => ({
  wrapper: {
    textAlign: 'center',
    height: '100%',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
}));

interface ImageRendererProps {
  url: string;
  alt?: string;
}

export default function ImageRenderer({url, alt = 'File preview'}: ImageRendererProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <div className={classes.wrapper}>
      <img className={classes.image} src={url} alt={alt} />
    </div>
  );
}
